import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Repeatability_Report_Filter from "./repeatability_report_filter/Repeatability_Report_Filter";
import Repeatability_Report_Table from "./repeatability_report_table/Repeatability_Report_Table";



const Repeatability_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Repeatability_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Repeatability_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Repeatability Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Repeatability_Report;
